import React, { useState, useEffect, useLayoutEffect, useRef } from "react"
import ReactDom from "react-dom"
import clsx from "clsx"

import classes from "./Modal.module.scss"

const Modal = props => {
  const {
    children,
    show = false,
    backdrop,
    size = "md",
    dialogClassName,
    contentClassName,
    onEnter = () => { },
    onHide = () => { },
    onExited = () => { },
    topBarComponent
  } = props

  const [mount, setMount] = useState(false)

  const ref = useRef(null)

  const handleClickOutsideContent = (e) => {
    const isInside = ref.current.contains(e.target)

    if (isInside) return

    if (backdrop === "static") return

    onHide()
  }

  const handleAnimationEnd = e => {
    e.stopPropagation()

    if (!show) {
      setMount(false)

      onExited()
    }
  }

  useLayoutEffect(() => {
    show && onEnter()
  }, [show])

  useEffect(() => {
    show && setMount(show)
  }, [show])

  return mount
    ?
    ReactDom.createPortal(
      <div
        id="modal"
        onAnimationEnd={handleAnimationEnd}
        className={clsx(
          classes["modal"],
          !show && classes["fade-out"]
        )}
      >
        <div
          className={classes["overlayer"]}
          onClick={() => backdrop !== "static" && onHide()}
        />

        {
          !!topBarComponent &&
          <div
            className={
              clsx(
                classes["show-topbar"],
                !show && classes["hide-topbar"]
              )}
          >
            {topBarComponent()}
          </div>
        }

        <div
          onClick={handleClickOutsideContent}
          className={clsx(
            classes["dialog"],
            classes[size],
            dialogClassName,
            !show && classes["dialog-hide"]
          )}
        >
          <div
            ref={ref}
            className={clsx(
              classes["content"],
              contentClassName
            )}
          >
            {children}
          </div>
        </div>
      </div>
      ,
      document.body
    )
    :
    null
}

export default Modal